import generateBasicEntityActions from "./generateBasicEntityActions";
import * as schemas from "../schemas";
import types from "./types";

const walletBalancingActions = {
  fetchAll: (clientId) => ({
    API_CALL: {
      httpMethod: "GET",
      endpoint: `/wallet_balancing/${clientId}`,
      schema: { walletBalancings: [schemas.walletBalancing] },
    },
  }),

  fetch: (id) => ({
    API_CALL: {
      httpMethod: "GET",
      endpoint: `/wallet_balancing/${id}/show`,
      schema: { walletBalancing: schemas.walletBalancing },
    },
  }),

  update: (id, entity) => {
    console.log("walletBalancingActions.update called with:", { id, entity });

    const payload = {
      API_CALL: {
        httpMethod: "PUT",
        endpoint: `/wallet_balancing/${id}`,
        params: { walletBalancing: entity },
        schema: { walletBalancing: schemas.walletBalancing },
      },
    };

    console.log("API_CALL payload:", payload);
    return payload;
  },
};

export default walletBalancingActions;
